<template>
  <page-wrapper :title="$t('page.myTicklers.title')">
    <search-result-template :config="config">

      <template #table-title>
        {{ $t('page.myTicklers.table.title') }}
      </template>

      <!--  Result Values  -->
      <template #v-data-table.item.caseHeader.caseNumber="{ item }">
        <div>
          <div style="white-space: nowrap">
            <router-link :to="{ name: 'caseView', params: { courtID: getCourtByExternalID(item.caseHeader.courtID).resourceID,
                                                            caseUUID: item.caseHeader.caseInstanceUUID} }">
              {{ item.caseHeader.caseNumber }}
            </router-link>
          </div>
        </div>
      </template>

      <!-- Search Criteria -->
      <template #nav-drawer-filter-body>
        <v-row no-gutters class="mt-4">
          <v-col v-if="!isSingleCourtMode" cols="12">
            <c-autocomplete
              :items="courts"
              v-model="searchDTO.courtID"
              item-text="displayName"
              item-value="resourceID"
              :label="$t('courtCase.court')"
              outlined
              key="courtID"
              hide-details="auto"
              aria-describedby="a15c521ed-92a4-4616-b9d1-a80d44675327"/>
            <field-description id="a15c521ed-92a4-4616-b9d1-a80d44675327"
                               message-key="page.myTicklers.court.description"/>
          </v-col>
          <v-col cols="12">
            <date-range-picker
              :label="$t('tickler.dueDate')"
              :labelStart="$t('tickler.dueDateFrom')"
              :labelEnd="$t('tickler.dueDateTo')"
              keyPrefix="ticklerDueDate"
              :inputAttributes="{ outlined: true }"
              :choice.sync="searchDTO.ticklerDueDateChoice"
              :startDate.sync="searchDTO.ticklerDueDateStart"
              :endDate.sync="searchDTO.ticklerDueDateEnd"
              aria-describedby="a188c3dd0-cad8-48c6-aa77-2d95de2ac6eb"/>
            <field-description id="a188c3dd0-cad8-48c6-aa77-2d95de2ac6eb"
                               message-key="page.myTicklers.dueDate.description"/>
          </v-col>
          <v-col cols="12">
            <c-autocomplete
              :items="statuses"
              v-model="searchDTO.statusID"
              item-text="displayName"
              item-value="resourceID"
              :label="$t('tickler.status')"
              outlined
              key="courtID"
              hide-details="auto"
              aria-describedby="207c9f60-926a-43d8-b65a-9bbe6d1df66d"/>
            <field-description id="207c9f60-926a-43d8-b65a-9bbe6d1df66d"
                               message-key="page.myTicklers.status.description"/>
          </v-col>

        </v-row>
      </template>

    </search-result-template>

  </page-wrapper>
</template>

<script>

import SearchResultTemplate from '@components/support/template/SearchResultTemplate';
import SearchResultTemplateMixin from '@/mixins/searchResultTemplate';
import _ from 'lodash';
import { dateToEndOfDay, dateToStartOfDay } from '@/application/application';

export default {
  components: { SearchResultTemplate },
  mixins: [ SearchResultTemplateMixin ],
  data () {
    return {
      statuses: [],
      searchDTO: {
        sort: {
          sortBy: 'dueDate',
          sortDesc: false
        },
        courtID: null,
        statusID: null,
        ticklerDueDateChoice: null,
        ticklerDueDateStart: null,
        ticklerDueDateEnd: null
      }
    };
  },
  methods: {
    getRouteName () {
      return 'work-ticklers';
    },
    getSearchAPIName () {
      // ????
      return 'api.search.user.cases';
    },
    getItemKey () {
      // ??? ticklerUUID
      return 'caseHeader.caseInstanceUUID';
    },
    getHeaders () {
      let headers = [];
      if (!this.isSingleCourtMode)
      {
        headers.push({ text: this.$t('courtCase.court'), value: 'caseHeader.courtAbbreviation', sortable: true });
      }

      headers.push({ text: this.$t('courtCase.caseNumber'), value: 'caseHeader.caseNumber', sortable: true });
      headers.push({ text: this.$t('courtCase.caseTitle'), value: 'caseHeader.caseTitle', sortable: true });
      headers.push({ text: this.$t('tickler.dueDate'), value: 'dueDate', sortable: true });
      headers.push({ text: this.$t('tickler.type'), value: 'dueDate', sortable: true });
      headers.push({ text: this.$t('tickler.status'), value: 'dueDate', sortable: true });
      headers.push({ text: this.$t('tickler.docketEntry'), value: 'dueDate', sortable: true });

      return headers;
    },
    addSearchCriteria (query) {

      if (!_.isNil(this.searchDTO.sort.sortBy))
      {
        query.sort = `${this.searchDTO.sort.sortBy},${this.searchDTO.sort.sortDesc ? 'desc' : 'asc'}`;
      }

      if (!_.isNil(this.searchDTO.courtID))
      {
        query['caseHeader.courtID'] = this.searchDTO.courtID;
      }

      if (!_.isNil(this.searchDTO.statusID))
      {
        query['???'] = this.searchDTO.caseHeader.caseCategoryID;
      }

      if (!_.isNil(this.searchDTO.ticklerDueDateStart))
      {
        query['???'] = dateToStartOfDay(this.$cove.parseDate(this.searchDTO.ticklerDueDateStart)).toISO();
      }

      if (!_.isNil(this.searchDTO.ticklerDueDateEnd))
      {
        query['???'] = dateToEndOfDay(this.$cove.parseDate(this.searchDTO.ticklerDueDateEnd)).toISO();
      }

      return query;
    },
    validateSearchCriteria (searchDTO)
    {
      this.$cove.validation.date.rejectIfInvalid(searchDTO.ticklerDueDateStart, 'tickler.dueDateFrom', 'ticklerDueDate-startDate');
      this.$cove.validation.date.rejectIfInvalid(searchDTO.ticklerDueDateEnd, 'tickler.dueDateTo', 'ticklerDueDate-endDate');
      this.$cove.validation.date.rejectIfBefore(searchDTO.ticklerDueDateEnd, searchDTO.ticklerDueDateStart,
        'tickler.dueDateTo', 'tickler.dueDateFrom', 'ticklerDueDate-endDate');
    }
  }
};
</script>

